// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8ad5481a","239":"eab4eb87","453":"75445ae1","849":"66fc58ac"}[chunkId] + ".chunk.js";
};